module.exports = __webpack_public_path__ + "media/role_selection/driver-d2ceb40a.png";